<template>
  <async-form autocomplete="off" novalidate="novalidate" @submit="onSubmit($event)" :class="['search-form']" :form-data="$root.search" :title="$lang.search">
    <card>
      <card-text>
        <text-field clearable :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :ripple-bg-color="$root.$colors.primary" :ripple-bg-color-lightness="$root.$colors.bgColorLightness" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" v-model="$root.search.q" icon-left="magnify" :placeholder="$lang.search" />
      </card-text>
    </card>
  </async-form>
</template>
<script>
export default {
  name: 'Search',
  data () {
    return {
      action: '/search'
    }
  },
  methods: {
    onSubmit ($event) {
      const q = $event.q
      if (q.length) {
        this.$router.push({
          query: {q},
          path: this.action
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search-form.vue